<template>
	<div class="bg-gray">
		<BaseNav></BaseNav>
		<div style="overflow:hidden;width:100%;margin:0 auto;min-height:1200px;text-align:center" id="hiddenBox">
			<iframe src="https://biz.hebotc.com/#/information" scrolling="no" height="1200"
				frameborder="0" width="100%"></iframe>
		</div>
		<BaseFooter></BaseFooter>
	</div>
</template>

<script>
	import BaseNav from "@/components/BaseNavigation"
	import BaseFooter from "@/components/BaseFooter"
	
	export default{
		components:{
			BaseNav,
			BaseFooter
		},
		data(){
			return{
				
			}
		}
	}
</script>

<style scoped="scoped">
	.bg-gray {
		background: #F6F7FC;
	}
</style>



// WEBPACK FOOTER //
// src/pages/special/information.vue